import {
  IGetAllPaginatedParams,
} from 'services/NGT/Log'
import { yup } from 'utils/yup'

export const DEFAULT_FORM_VALUES: IGetAllPaginatedParams = {
  txPesquisa: '',
  dtInicio: null,
  dtFim: null,
  txUsuario: '',
  txNmApi: null,
  txNivelLog: null,
}

export const VALIDATION_SCHEMA = yup.object({
  dtInicio: yup.string()
    .optional()
    .date()
    .daterange({
      period: 'begin',
      message: 'Data início não pode ser maior que data fim.',
      compare: 'dtFim',
      options: {
        compareEqual: true,
      },
    })
    .nullable(),
  dtFim: yup.string()
    .optional()
    .date()
    .daterange({
      period: 'end',
      message: 'Data fim não pode ser menor que data início.',
      compare: 'dtInicio',
      options: {
        compareEqual: true,
      },
    })
    .nullable(),
})
